<script setup>
import { onMounted, onUnmounted } from 'vue';
import DigitalDisplayHeader from '@/js/core/components/parts/digital-display/DigitalDisplayHeader.vue';
import DigitalDisplayEventList from '@/js/core/components/parts/digital-display/DigitalDisplayEventList.vue';
import DigitalDisplayPagination from '@/js/core/components/parts/digital-display/DigitalDisplayPagination.vue';
import { useDigitalDisplayChrome } from '@/js/core/composables/useDigitalDisplayChrome';
import { useDigitalDisplayEvents } from '@/js/core/composables/useDigitalDisplayEvents';
import { DEFAULT_TIMEZONE } from '@/js/core/utils/timezone';

useDigitalDisplayChrome();

const timezone = DEFAULT_TIMEZONE;
const {
  currentSlide,
  slideCount,
  slideIndex,
  pageTitle,
  isLoading,
  error,
  refresh,
  startSlideCycle,
  stopSlideCycle,
} = useDigitalDisplayEvents({ timezone });

onMounted(async () => {
  await refresh();
  startSlideCycle();
});

onUnmounted(stopSlideCycle);
</script>

<template>
  <main class="digital-display--main-content">
    <DigitalDisplayHeader :title="pageTitle" />

    <section class="digital-display__events">
      <Transition name="dd-fade" mode="out-in">
        <p v-if="isLoading" key="loading">Loading events…</p>
        <p v-else-if="error" key="error">{{ error }}</p>
        <DigitalDisplayEventList
          v-else
          :key="slideIndex"
          :events="currentSlide"
          :timezone="timezone"
        />
      </Transition>
    </section>

    <DigitalDisplayPagination :count="slideCount" :index="slideIndex" />
  </main>
</template>
